import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function BookingsCard({
  icon,
  bookingTitle,
  bookingCount,
}) {
  return (
    <div className=" w-full bg-white p-4 rounded-xl h-full shadow-card_shadow  lg:min-h-max">
      <div className="flex flex-row gap-5">
        <div className="flex items-center gap-4">
          <div className="flex justify-center items-center gap-4 bg-accent rounded-full w-10 h-10 text-white p-2">
            {icon}
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <p className="headingText text-coalBlack capitalize">
            {bookingTitle}
          </p>

          <div className="flex flex-row gap-2 items-center">
            <p className="headingText text-coalBlack  text-center">
              {bookingCount}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingsCard;

